var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style.dot,style:(`background: ${_vm.color || '#fff'}; width: ${_vm.size || 4}px; height: ${_vm.size || 4}px;`),on:{"click":function($event){return _vm.$emit('click')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }